const ID_TOKEN_KEY = "id_token";
const setCookie = (name,value,days) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/;SameSite=Lax";
};
const getCookie = (name) => {
  const nameEQ = name + "=";
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let c = cookies[i];
    while (c.charAt(0)===' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
  }
};


const eraseCookie = (name) => {
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

export default {
  getToken() {
    return getCookie(ID_TOKEN_KEY);
  },

  saveToken(token) {
    setCookie(ID_TOKEN_KEY, token, 360);
  },

  destroyToken() {
    eraseCookie(ID_TOKEN_KEY);
  }
};
